import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { NavMenu } from '../components/NavMenu';
import { LoginRedirect } from '../components/LoginRedirect';
import Authorization from '../components/Authorization';

class Layout extends Component {
  displayName = Layout.name

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col sm={3}>
            <NavMenu />
          </Col>
          <Col sm={9}>
            {this.props.children}
          </Col>
        </Row>
      </Grid>
    );
  }
}

export const SecuredLayout = Authorization(Layout, LoginRedirect, 'Admin');